import React, { FunctionComponent, useCallback, useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';

import { FormContainer } from './styles';
import { setMinBalance } from '../../Listing/promiseAction';
import { showToaster } from '../../../Toaster/action';
import { sendEvent2, sendToGA } from '../../../../utils/tracking';
import Input from '../../../UI/InputWithIcon';

const RechargeForm: FunctionComponent<{
  tagId: string;
  vehicle: string;
  updateAction: Function;
  recharge: boolean;
  walletBalance: number;
}> = ({ tagId, vehicle, updateAction, recharge, walletBalance }) => {
  const { register, handleSubmit } = useForm();
  const dispatch = useDispatch();

  const [error, setError] = useState('');

  const dispatchToStore = useCallback(
    (payload) =>
      dispatch(setMinBalance(payload))
        .then((resp: any) => {
          const { data = {} } = resp;
          if (!data.success) {
            setError(data && data.message);
            return;
          }
          updateAction(false);
          dispatch(
            showToaster({
              msg: `Auto-Recharge balance to be maintained updated for ${vehicle}.`,
              timeout: 5000,
              success: true,
            }),
          );
        })
        .catch((err: any) => {
          setError(err && err.message);
        }),
    // TODO: handle dependencies updateAction, vehicle
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dispatch],
  );

  const onSubmit = (data?: any) => {
    const { amount } = data;
    let msg = !amount || isNaN(amount) ? 'Invalid amount' : '';
    sendEvent2(
      'save_btn',
      {
        event_action: 'click',
        event_category: 'maintain_min_bal_pop_up',
        screen_name: 'ft_homescreen',
        miscellaneous: JSON.stringify({
          minimum_balance: amount,
        }),
        target_product: 'fastag',
        event_platform: 'web',
      },
      true,
    );
    if (msg) {
      setError(msg);
    } else {
      setError('');
      sendToGA('click', 'Maintain Balance', 'Fastag');
      dispatchToStore({ fastagId: tagId, minBalance: +data.amount, autoRechargeActivate: true });
    }
  };
  useEffect(() => {
    sendEvent2(
      'pop_up_view',
      {
        event_action: 'view',
        event_category: 'maintain_min_bal_pop_up',
        screen_name: 'ft_homescreen',
        target_product: 'fastag',
        event_platform: 'web',
      },
      true,
    );
  }, []);

  return (
    <FormContainer>
      <p className="fwb mb16 pr30">Set Automatic Balance to maintain in {vehicle}</p>
      <div className="mt24">
        <form className="form-container" onSubmit={handleSubmit(onSubmit)}>
          <p className="small mb8 font-light-grey form-label">Enter Amount</p>
          <div className="flex">
            <Input
              handleChange={() => setError('')}
              register={register}
              type="number"
              placeholder="1000"
              name="amount"
            />
            <input className="form-btn" type="submit" value="Save" />
          </div>
          <p className={`form-error ${error ? 'mt8' : 'hide'}`}>{error}</p>
        </form>
      </div>
    </FormContainer>
  );
};

export default RechargeForm;
